















































import {
    DEFAULT_NETWORK,
    DEFAULT_NETWORK_NAME,
} from '@/store/modules/network/network'
import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { abbreviateBech32, abbreviateHex } from '@/helper'
import CopyText from '@/components/misc/CopyText.vue'

@Component({
    components: {
        CopyText,
    },
})
export default class AddressLink extends Vue {
    @Prop() address!: string

    get isBech32() {
        const prefix = this.address.substring(0, 2)
        return prefix !== '0x' ? true : false
    }

    get internalURL() {
        return `/address/${this.address}?network=${DEFAULT_NETWORK_NAME}`
    }

    get externalURL() {
        // return `${
        //     DEFAULT_NETWORK_ID === 1
        //         ? actChainExplorerURL
        //         : actChainExplorerURL_test
        // }/evmaddress/${this.address}`
        return `${DEFAULT_NETWORK.ACTCHAIN_EXPLORER_URL}/evmaddress/${this.address}?network=${DEFAULT_NETWORK_NAME}`
    }

    get abbrev32() {
        return abbreviateBech32(this.address)
    }

    get abbrevHex() {
        return abbreviateHex(this.address)
    }
}
